export default "__VITE_ASSET__DbJpmGTg__"